<swiper-container
  class="full-width"
  slides-per-view="1"
  loop="true"
  autoplay="true"
  autoplay-delay="12000"
  autoplay-disable-on-interaction="true"
  >
  @for (a of announcements | async; track a) {
    <swiper-slide>
      <a
        class="announcement-header-item"
        [attr.href]="a.link"
        [style.background]="a.color"
        >
        @if (a.icon.length > 0) {
          <img [src]="a.icon" alt="a.title" />
        }
        <span> {{ a.title }}</span>
      </a>
    </swiper-slide>
  }
</swiper-container>
